class instaCart extends HTMLElement {

	constructor(){
		super();
        this.closeButton = this.querySelector('.insta-cart__close');
        this.minutesToAppear = this.dataset.minutes || 0

        this.init();
	}

    setListeners() {
        this.closeButton.addEventListener('click', () => this.setNewDate())
    }

    setNewDate() {
        
        localStorage.setItem('instaCart', JSON.stringify({
            lastAppearance: new Date().getTime()
        }))

        this.classList.remove('show')
    }

    checkStorage() {
        let storage = JSON.parse(localStorage.getItem('instaCart'))
        let minuteInMS = 60000;

        if (!!!storage) {
            this.classList.add('show')
            return;
        }

        let timeDiff = new Date().getTime() - storage.lastAppearance
        let minutesDiff = timeDiff / minuteInMS

        if (minutesDiff > Number(this.minutesToAppear)) this.classList.add('show')

    }

	init() {
        this.setListeners();
        this.checkStorage();
    }
}
customElements.define('insta-cart', instaCart);